export const AUSTRALIAN_STATES = [
  {
    label: 'NSW',
    value: 'NSW',
  },
  {
    label: 'QLD',
    value: 'QLD',
  },
  {
    label: 'SA',
    value: 'SA',
  },
  {
    label: 'VIC',
    value: 'VIC',
  },
  {
    label: 'WA',
    value: 'WA',
  },
  {
    label: 'TAS',
    value: 'TAS',
  },
  {
    label: 'NT',
    value: 'NT',
  },
  {
    label: 'ACT',
    value: 'ACT',
  },
];

export const AUSTRALIAN_STATE_TO_TIMEZONE: Record<string, string> = {
  NSW: 'Australia/Sydney',
  QLD: 'Australia/Brisbane',
  VIC: 'Australia/Sydney',
  TAS: 'Australia/Hobart',
  NT: 'Australia/Darwin',
  SA: 'Australia/Adelaide',
  WA: 'Australia/Perth',
  ACT: 'Australia/Canberra',
};
